import Vue from 'vue'

export async function getReglasFromProveedor(context, [access_token, proveedor_id, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
               context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/proveedores/' + proveedor_id + '/reglas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
              
            })

            context.commit('reglas/setReglas', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading) {
          context.commit('setLoading', false, { root: true })
        }
    }
}


export async function crearRegla(context, [access_token, modelRegla, mTarifasReglas]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/reglas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    modelRegla,
                    tarifas: mTarifasReglas
                }   
            })
            return response;
        }

    } catch (e) {
    } finally {
        //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateRegla(context, [access_token,
    modelRegla,
    mTarifasReglas]) {
    try {
        if (access_token) {

            const response = await Vue.axios({
                method: 'PUT',
                url: '/reglas/' + modelRegla.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    modelRegla,
                    tarifas: mTarifasReglas,
                }
            })
            console.log('response:', response);
            if (response.status == 200) {
                context.commit('reglas/actListReglas', response.data.data, { root: true })
            }
            return response;
            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarRegla(context, [access_token, regla_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/reglas/' + regla_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })


            if (response.status == 200) {
                context.commit('reglas/actDeleteListReglas', regla_id, { root: true })
            }
            return response;

            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}

